import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useCustomerMessage } from "./CustomerMessageHook";
import { useCustomerHistoryContext } from "../customer-history/CustomerHistoryContext";
import { useCustomerContext } from "../customer/CustomerContext";
// Set the default state values for each context
const CustomerMessageContext = /*#__PURE__*/createContext({});
export const CustomerMessageContextProvider = ({
  children
}) => {
  const hook = useCustomerMessage();
  const {
    history
  } = useCustomerHistoryContext();
  const {
    customer
  } = useCustomerContext();
  const {
    stateTracker
  } = useDevLogging();
  const context = useMemo(() => {
    stateTracker.trackState({
      message: hook.message
    });
    return {
      ...hook
    };
  }, [hook.message, hook.hasFinishedCreating, history, customer, hook.previewImage]);

  // pass the value in provider and return
  return /*#__PURE__*/React.createElement(CustomerMessageContext.Provider, {
    value: context
  }, children);
};
export const useCustomerMessageContext = () => {
  return useContext(CustomerMessageContext);
};
CustomerMessageContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};